import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import './index.css'
import { Start } from './Start'
import { logger } from './util/logger'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Start />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      // this service worker is generated with workbox https://developer.chrome.com/docs/workbox/modules/workbox-cli/
      // basically `npx workbox-cli wizard` and follow the instructions, and add it to your build pipeline.
      // but in addition, this code needs to register the generated sw
      .register('/sw.js')
      .then((registration) => {
        logger.debug('SW registered: ', registration)
      })
      .catch((registrationError) => {
        logger.debug('SW registration failed: ', registrationError)
      })
  })
}
